
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokeGetAllGenAIReviewedSubmissions } from '@/utils/admin/task_management_service';
import Generic from '@/components/global/GenericModal.vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokegetSkillProf } from '@/utils/admin/assign_proxy_service';
import { createZipFromUrls } from '@/utils/admin/zip';
import { DownloadIcon } from 'vue-feather-icons';
import RangeSlider from '@/components/global/RangeSlider.vue';

export default defineComponent({
  name: 'GenAIReviewedSubmissions',

  components: { Generic, DownloadIcon, RangeSlider },

  setup() {
    const fromRange = ref(10);
    const toRange = ref(90);
    const renderReady = ref(true);
    const submissions = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const successMessage = ref();
    const skills = ref();
    const proficiency = ref();
    const selectedSkill = ref(null);
    const selectedProficiency = ref(null);
    const modalVisible = ref(false);
    const modalMessage = ref();
    const filteredSubmissions = ref();

    onBeforeMount(async () => {
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Community Manager') || userRole.value.includes('Program Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
      await getSkillandProf();
    });

    const getSkillandProf = async () => {
      renderReady.value = false;
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };

    const getSubmissions = async () => {
      if (!selectedSkill.value || !selectedProficiency.value) return;
      renderReady.value = false;
      const payload = {
        skillId: selectedSkill.value,
        proficiencyId: selectedProficiency.value,
        fromRange: fromRange.value,
        toRange: toRange.value,
      };
      submissions.value = await invokeGetAllGenAIReviewedSubmissions('/learners/submissions', payload);
      console.log('submissions', submissions.value);
      filteredSubmissions.value = submissions.value;
      renderReady.value = true;
    };

    const downloadZip = () => {
      createZipFromUrls(filteredSubmissions.value, 'genome_solidify_tasks_2025_04_17').catch(console.error);
    };

    const onUpdate = ({ min, max }: { min: number; max: number }) => {
      fromRange.value = min;
      toRange.value = max;
    };

    const closeModal = () => {
      modalVisible.value = false;
    };

    return {
      fromRange,
      toRange,
      renderReady,
      submissions,
      showScreen,
      successMessage,
      skills,
      proficiency,
      selectedSkill,
      selectedProficiency,
      modalVisible,
      modalMessage,
      filteredSubmissions,
      getSubmissions,
      downloadZip,
      closeModal,
      onUpdate,
    };
  },
});
